<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.TransactionCode }}</td>
                <td>{{ item.Username }}</td>
                <td>{{ item.ProductType | display_value(productTypes) }}</td>
                <td>{{ item.BigPackageCode }}</td>
                <td>{{ item.BigPackageVNCode }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, packageStatus)}">{{ item.Status | display_value(packageStatus) }}</td>
                <td class="text-end">{{ item.NumberOfPack | currency}}</td>
                <td class="text-end">{{ item.Weight | currency('', 2)}}</td>
                <td class="text-end">{{ item.Volume | currency('', 2)}}</td>
                <td class="text-end">{{ item.FeeShip | currency('', 2)}}</td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td>{{ item.StoreTQDate | display_date }}</td>
                <td>{{ item.StoreVNDate | display_date }}</td>
                <td>{{ item.PaymentDate | display_date }}</td>
                <td v-if="userRole != roleType.Customer">{{ item.CreatedBy }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    return {
      packageStatus: configs.PACKAGE_STATUS,
      import_pagination: {...configs.PAGINATION, itemsPerPage: 10},
      import_items_per_page: {'items-per-page-options': [10, 20, 30, 40, 50]},
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "tracking_list",
      productTypes: configs.PRODUCT_TYPE_LIST,
      roleType: configs.ROLE_TYPE,
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      selectedCustomerId: 0,
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    userRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: true});
    }
  },
  computed: {
    ...mapState({
      customers: state => state.customer.master.data,
      items: state => state.tracking.track_items.data,
      total_rows: state => state.tracking.track_items.total,
      currentItem: state => state.tracking.selected,
      loading: state => state.tracking.loading
    }),
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
    headers() {
      let hd = [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Hàng",
          value: "ProductType",
          sortable: true,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.PRODUCT_TYPE_LIST
        },
        {
          text: "Mã bao",
          value: "BigPackageCode",
          sortable: true,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Bill",
          value: "BigPackageVNCode",
          sortable: true,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          sortable: true,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.PACKAGE_STATUS
        },
        {
          text: "S.Kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "KG",
          value: "Weight",
          align: "end",
          decimal: 1,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "M3",
          value: "Volume",
          align: "end",
          decimal: 1,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "P.Ship (¥)",
          value: "FeeShip",
          align: "end",
          decimal: 2,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Nhập kho TQ",
          value: "CreatedDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Đóng bao",
          value: "StoreTQDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Nhập kho VN",
          value: "StoreVNDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Xuất kho VN",
          value: "PaymentDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        }
      ];
      if(this.userRole != this.roleType.Customer){
        hd.push({
          text: "Người tạo",
          value: "CreatedBy",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        });
      }
      return hd;
    }
  },
  methods: {
    filter_data: function() {
      if(this.userRole == configs.ROLE_TYPE.Customer) {
        if(this.quickFilterConditions.length == 0) {
          this.$store.commit("tracking/setListTracking", {data: [], total: 0});
        }
        else {
          var param = {
            pagination: this.pagination,
            filter: [],
            quickFilter: this.quickFilterConditions.map(obj =>{ 
              return {
                column: obj.column,
                value: obj.value,
                condition: "contain"
              };
            })
          };
          this.$store.dispatch("tracking/getListTracking", param);
        }
      }
      else{
        var param = {
          pagination: this.pagination,
          filter: this.filterConditions,
          quickFilter: this.quickFilterConditions
        };
        this.$store.dispatch("tracking/getListTracking", param);
        this.getCustomerList();
      }
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Username"]
      });
    },
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: true});
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_CREATE_DATA", this.import_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("REQUEST_CREATE_DATA", this.import_data);
  }
};
</script>
